import React, { useState, useRef } from "react";
import { apiCall } from "../assets/js/common.js";
import alertify from "alertifyjs";
import * as Constants from "../config/constants.js";
import ReCaptchaV2 from "../component/ReCaptchaV2.js";

export default function NewsletterForm({ title = "Subscribe to our newsletter" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const recaptchaRef = useRef(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      alertify.error("Please enter your email address.");
      return;
    }
    const token = recaptchaRef.current?.getResponse();
    if (!token) {
      alertify.error("Please verify that you are not a robot.");
      return;
    }
    setLoading(true);
    const payload = new URLSearchParams();
    payload.append("email", email);
    payload.append("g-recaptcha-response", token);
    const res = await apiCall("post", "newsletter/subscribe", payload, true);
    setLoading(false);
    if (res?.status !== false && res?.data?.status_code === 1) {
      alertify.success(res?.data?.message || "Subscribed successfully.");
      setEmail("");
    } else {
      alertify.error(res?.data?.message || "Subscription failed.");
    }
  };

  return (
    <div className="newsletter-box">
      <h5 className="mb-3">{title}</h5>
      <form onSubmit={submit}>
        <div className="d-flex gap-2" style={{ maxWidth: '500px' }}>
          <input
            type="email"
            className="form-control"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button className="primary-arrow-btn" disabled={loading}>
            {loading ? "..." : "Subscribe"}
          </button>
        </div>
        <p style={{ color: 'grey', fontSize: '13px', marginTop: '6px' }}>No spam. Just insights.</p>
        <div className="w-100 mt-2">
          <ReCaptchaV2 ref={recaptchaRef} siteKey={Constants.RECAPTCHA_SITE_KEY} className="g-recaptcha" />
        </div>
      </form>
    </div>
  );
}
